<template>
    <table cellspacing="0" cellpadding="0" border="0" :style="styleObject">
        <colgroup>
            <col v-for="(column, index) in columns" :width="setCellWidth(column)">
        </colgroup>
        <tbody :class="[prefixCls + '-tbody']">
            <template v-for="(row, index) in data">
                <table-tr
                    v-if="rowShow(row._index)"
                    :row="row"
                    :key="row._rowKey"
                    :prefix-cls="prefixCls"
                    @mouseenter.native.stop="handleMouseIn(row._index)"
                    @mouseleave.native.stop="handleMouseOut(row._index)"
                    @click.native="clickCurrentRow(row._index)"
                    @dblclick.native.stop="dblclickCurrentRow(row._index)">
                    <td v-for="column in columns" :class="alignCls(column, row)">
                        <Cell
                            :ref="'cell'+column._columnKey+row._index"
                            :fixed="fixed"
                            :prefix-cls="prefixCls"
                            :row="row"
                            :rowOriginal="dataOriginal[index]"
                            :key="column._columnKey"
                            :column="column"
                            :editAlways="editAlways"
                            :natural-index="index"
                            :index="row._index"
                            :checked="rowChecked(row._index)"
                            :disabled="rowDisabled(row._index)"
                            :expanded="rowExpanded(row._index)"
                        ></Cell>
                    </td>
                </table-tr>
                <tr v-if="rowExpanded(row._index)" :class="{[prefixCls + '-expanded-hidden']: fixed}">
                    <td :colspan="columns.length" :class="prefixCls + '-expanded-cell'">
                        <Expand :key="row._rowKey" :row="row" :render="expandRender" :index="row._index"></Expand>
                    </td>
                </tr>
            </template>
        </tbody>
    </table>
</template>
<script>
    // todo :key="row"
    import TableTr from './table-tr.vue';
    import Cell from './cell.vue';
    import Expand from './expand.js';
    import Mixin from './mixin';

    export default {
        name: 'TableBody',
        mixins: [ Mixin ],
        components: { Cell, Expand, TableTr },
        props: {
            prefixCls: String,
            styleObject: Object,
            columns: Array,
            data: Array,    // rebuildData
            dataOriginal:Array,
            objData: Object,
            columnsWidth: Object,
            fixed: {
                type: [Boolean, String],
                default: false
            },
            editAlways:{
                type: Boolean
            },
        },
        computed: {
            expandRender () {
                let render = function () {
                    return '';
                };
                for (let i = 0; i < this.columns.length; i++) {
                    const column = this.columns[i];
                    if (column.type && column.type === 'expand') {
                        if (column.render) render = column.render;
                    }
                }
                return render;
            }
        },
        methods: {
            rowChecked (_index) {
                return this.objData[_index] && this.objData[_index]._isChecked;
            },
            rowDisabled(_index){
                return this.objData[_index] && this.objData[_index]._isDisabled;
            },
            rowShow(_index){
                return this.objData[_index] && !this.objData[_index]._isHide;
            },
            rowExpanded(_index){
                return this.objData[_index] && this.objData[_index]._isExpanded;
            },
            handleMouseIn (_index) {
                this.$parent.handleMouseIn(_index);
            },
            handleMouseOut (_index) {
                this.$parent.handleMouseOut(_index);
            },
            clickCurrentRow (_index) {
                this.$parent.clickCurrentRow(_index);
            },
            dblclickCurrentRow (_index) {
                this.$parent.dblclickCurrentRow(_index);
            },
            validator(dataList){
                if(dataList&&dataList.length>0){
                    let isChecked=false
                    for (let i = 0; i < dataList.length; i++) {
                        let row = dataList[i];
                        for (let j = 0; j < this.columns.length; j++) {
                            let col = this.columns[j];
                            if(col.key&&col.rules){
                                //如果只要有一个校验不过
                                if(isChecked){
                                    return false
                                }
                                // console.log(i+' ddd '+j)
                                let cell=this.$refs['cell'+col._columnKey+row._index][0]||{}
                                this.$utils.when(cell.validator(row[col.key])).done(function (result, name) {
                                    isChecked=result
                                })
                            }
                        }
                    }
                    //如果只要有一个校验不过
                    if(isChecked){
                        return false
                    }
                }
                // console.log("ccccc")
                return true
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/common/table/table-body.vue